export default "__VITE_ASSET__DoYWFKmD__"